define.alias("ember-useragent/instance-initializers/user-agent", "media/instance-initializers/user-agent");